module.exports = __webpack_public_path__ + "img/1280.d52a9d92.svg";